module.exports = __webpack_public_path__ + "img/puja.f3c08298.jpeg";